module.exports = __webpack_public_path__ + "static/media/028_IMG_3486.040ee565.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/028_IMG_3486.png
// module id = 407
// module chunks = 0